import { FC } from 'react';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import ChipInput from 'components/ChipInput';

const HotelEditMainPresentation: FC = () => (
  <Section id="presentation" title="Pristatymas">
    <Stack spacing={4}>
      <ChipInput name="features" label="Apie viešbutį" />
      <ChipInput name="reviews" label="Atsiliepimai" />
    </Stack>
  </Section>
);

export default HotelEditMainPresentation;
